import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// PWA: register the service worker so Android Chrome offers
// "Install app" (standalone, no browser badge).
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {});
  });
}

// PWA: capture the install prompt EARLY (it can fire before React mounts).
// The in-app "Install ReUP" button (InstallPWAButton) consumes it.
window.__reupInstallPrompt = null;
window.addEventListener("beforeinstallprompt", (e) => {
  e.preventDefault();
  window.__reupInstallPrompt = e;
  window.dispatchEvent(new Event("reup-install-available"));
});
